/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
import{defaultCIMValues as t}from"./defaultCIMValues.js";const e=15.5,i=4,o=64,r=1024,l={outlineWidth:.75,referenceWidth:.75,cap:t.CIMSolidStroke.capstyle,join:t.CIMSolidStroke.joinstyle,miterLimit:t.CIMSolidStroke.miterlimit};export{l as antialiasingOutlineFillSettings,e as dashRadius,o as dashSdfDistanceNormalization,i as dashSdfRasterizationScale,r as maxTileCoordValue};
